<template>
    <img
        :src="backgroundImage"
        class="background-image"
        :style="backgroundImageStyle"
    />
    <div
        class="background-image-overlay"
        :style="backgroundImageOverlayStyle"
    ></div>
    <div
        v-if="height !== '100'"
        class="background-image-border"
        :style="`top: ${height}vh`"
    ></div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'

export default defineComponent({
    name: 'BackgroundImage',
    props: {
        image: { type: String, default: 'landing' },
        position: { type: String, default: 'top' },
        height: { type: String, default: '80' },
        useParallax: { type: Boolean, default: false },
    },
    setup(props) {
        const backgroundImage = computed(() => {
            return require(`@/assets/images/${props.image}.jpg`)
        })

        const backgroundImageStyle = computed(() => {
            return `object-position: ${props.position}; height: ${props.height}vh;`
        })

        const backgroundImageOverlayStyle = computed(() => {
            return `height: ${props.height}vh;`
        })

        return {
            backgroundImage,
            backgroundImageStyle,
            backgroundImageOverlayStyle,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
@import '../../styles/mixins';

.background-image,
.background-image-overlay {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
}

.background-image-border {
    position: absolute;
    width: 100%;
    height: 20px;
    z-index: 3;
    background: linear-gradient(
        to right,
        lighten($accent-color, 60%),
        lighten($accent-color, 45%)
    );

    @include mQ(700px) {
        height: 5px;
    }
}

.background-image {
    object-fit: cover;
    z-index: 1;
}

.background-image-overlay {
    background: linear-gradient(
        to bottom right,
        rgba(255, 255, 255, 0.7),
        rgba($accent-color-very-light, 0.95)
    );
    z-index: 2;
}
</style>
